import { useEffect } from 'react';
import { useUiStore } from '../../store/ui';
import styles from './Toast.module.css';

const TOAST_MS = 2800;

export function Toast() {
  const toast = useUiStore((s) => s.toast);
  const setToast = useUiStore((s) => s.setToast);

  useEffect(() => {
    if (!toast) return;
    const id = window.setTimeout(() => setToast(null), TOAST_MS);
    return () => window.clearTimeout(id);
  }, [toast, setToast]);

  if (!toast) return null;
  return (
    <div className={styles.toast}>
      <span className={styles.check}>✓</span>
      {toast}
    </div>
  );
}
